import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-expenditure-graph',
  templateUrl: './expenditure-graph.component.html',
  styleUrls: ['./expenditure-graph.component.scss']
})
export class ExpenditureGraphComponent implements OnInit {
  loader: boolean = false
  _apisub: Subscription

  expenditureData: any[] = []
  expenditureGraphData: any
  constructor(private _apiservice: ApiService) { 

    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_COMPOSITE_EXPENDITURE_DATA_FOR_DASHBOARD){
        this.expenditureData = []
        if(resdata.result){
          this.expenditureData = resdata.result
     
          //   this.expenditureGraphData = {
          //     datasets: [{
          //         label: 'Expenditure',
          //         data: this.expenditureData.map(item => {
          //           return item.amount
          //       }),
          //         // backgroundColor: "rgb(115 185 243 / 65%)",
          //         borderColor: "#007ee7",
          //         fill: false,
          //         lineTension: 0
          //     }
          //     ],
          //     labels: this.expenditureData.map(item => {
          //       return new Date(item.date).toLocaleDateString()
          //   })
        
          // }


          // NEW WAY

          // Flatten the data and group by business
const uniqueBusinesses = new Map<string, string>();

this.expenditureData.forEach(dataItem => {
    const dataArray = JSON.parse(dataItem.data);
    dataArray.forEach((entry:any) => {
        uniqueBusinesses.set(entry.entity_hash, entry.entity_name);
    });
});

// Get all unique dates for the x-axis
const allDates = [...new Set(this.expenditureData.map(dataItem => new Date(dataItem.date).toLocaleDateString()))].sort();

// Prepare datasets for the graph
const datasets = Array.from(uniqueBusinesses.entries()).map(([entityHash, entityName], index) => {
    return {
        label: entityName,
        data: allDates.map(date => {
            // Find expenditure data for this business on the current date
            const matchingData = this.expenditureData.find(dataItem => {
                return new Date(dataItem.date).toLocaleDateString() === date;
            });

            if (matchingData) {
                const dataArray = JSON.parse(matchingData.data);
                const businessData = dataArray.find((entry:any) => entry.entity_hash === entityHash);
                if (businessData) {
                    return businessData.amount; // Use the `amount` field for expenditure
                }
            }
            return 0; // Default to 0 if no data found for this business on this date
        }),
        borderColor: this.getDistinctColor(index, uniqueBusinesses.size), // Use distinct colors for each business
        fill: false,
        lineTension: 0
    };
});

// Assign the data to the graph

const expenditureData = this.expenditureData; // Reference data outside the callback
 


this.expenditureGraphData = {
    datasets,
    labels: this.formatDateToReadable(allDates),
    options: {
      tooltips: {
          callbacks: {
              label: function (tooltipItem:any, data:any) {
                  const dataset = data.datasets[tooltipItem.datasetIndex];
                  const value = dataset.data[tooltipItem.index];
                  const entityName = dataset.label;

                  // Find matching row for the current date and entity
                  const date = allDates[tooltipItem.index];
                  const matchingData = expenditureData.find(dataItem =>
                      new Date(dataItem.date).toLocaleDateString() === date
                  );

                  let currencySymbol = '';
                  if (matchingData) {
                      const parsedData = JSON.parse(matchingData.data);
                      const businessData = parsedData.find((entry:any) => entry.entity_name === entityName);
                      if (businessData) {
                          currencySymbol = businessData.currency_symbol; // Use the provided currency symbol
                      }
                  }

                  // Custom label format
                  const formattedValue = value === 0 ? '0' : `${currencySymbol}${value}`;
                  return `${entityName}: ${formattedValue}`;
              }
          }
      },
      responsive: true,
      maintainAspectRatio: false
  }
};
          
        }
        this.loader = false
      }
    })

  }

  ngOnInit(): void {
    this.loader = true
    this._apiservice.getCompositeExpenditureDataForDashboard()
  }

  getDistinctColor(index: number, total: number): string {
    const hue = (index / total) * 360; // Spread hues evenly across 360 degrees
    return `hsl(${hue}, 70%, 50%)`; // Vibrant and distinguishable colors
}

formatDates(dateArray:any) {
  return dateArray.map((dateString:any) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name
      return `${day} ${month}`;
  });
}

formatDateToReadable(dateArray: any[]): string[] {
  console.log("dates", dateArray);

  return dateArray.map((dateString: string) => {
    // Parse DD/MM/YYYY format manually
    const [day, month, year] = dateString.split('/').map(Number);

    // Create a valid Date object (month is zero-based in JavaScript)
    const parsedDate = new Date(year, month - 1, day);

    // Check if the parsedDate is valid
    if (isNaN(parsedDate.getTime())) {
      console.error(`Invalid date format: ${dateString}`);
      return "Invalid Date"; // Or handle the error as needed
    }

    // Format the valid date as 'dd MMM'
    return formatDate(parsedDate, 'dd MMM', 'en-US');
  });
}
}